export default "__VITE_ASSET__gqxWUHXB__"